import React, { useState, useEffect } from "react";
// import '../../../sass/components/flexibleModules/_components.performTicketSectionComponent.scss';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Slider from "react-slick";
import "../../../sass/slick/slick.min.scss";
import "../../../sass/slick/slick-theme.min.scss";

const Perform2023LogosSection = ({ data }) => {
    const [isRendered, setIsRendered] = useState(false);

    let settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        cssEase: 'linear',
        arrows: false,
        speed: 3000,
        slidesToShow: 6,
        slidesToScroll: 1,
        draggable: true,
        centerMode: false,
        swipeToSlide: true,
        touchThreshold: 250,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    };

    useEffect(() => {
        setIsRendered(true);
    }, []);

    return (
        <div className="cp-performLogosSection">
            <div className="cp-performLogosSection__inner" data-aos="fade-up">
            {isRendered &&
                        <Slider {...settings}>
                            {data.perform23Logos.map((gridItems, index) => (
                                <React.Fragment key={index}>
                                    <div className="l-gridLogos" key={index}>
                                        {gridItems &&
                                            <GatsbyImage image={getImage(gridItems.gatsbyImage)} alt={gridItems.altText} />
                                        }
                                    </div>
                                </React.Fragment>
                            ))}
                        </Slider>
                    }
            </div>
        </div>
    );
}

export default Perform2023LogosSection;